'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* eslint no-undef: "off" */
/**
 * search modal
 */
define('searchModal',['busEvent', 'jquery', 'util', 'searchSortApi', 'GAReport'], function (busEvent, $, Util, searchSortApi, GAReport) {
  return {
    template: '\n      <div class="xp-search-container" @click.stop="onSearchModalClicked">\n        <transition name="fade">\n          <div class="xp-search-content">\n            <div class="xp-search-box-area">\n              <input @focus="onInputFocus" @keyup.enter="submit" class="xp-search-box" type="text" ref="searchInput" :placeholder="i18n.find" v-model.trim="keyWords" />\n              <span @click="submit" class="search-icon-btn"><img :src="require.toUrl(\'images/home-search.png\')" class="home-search"/></span>\n            </div>\n            <div v-show="showModal" class="xp-search-modal">\n              <div class="search-history-head">\n                <span v-text="i18n.history"></span>\n                <img :src="require.toUrl(\'images/search_delete.png\')" @click.prevent="deleteHistory"/>\n              </div>\n              <div class="history-content">\n                <p>\n                  <a class="search-history" @click="onSearchWordClicked(\'history\', item)" v-for="item in searchHis" :href="\'/catalogsearch/result/?q=\' + item">{{item}}</a>\n                </p>\n              </div>\n              <div v-show="isKeyWordsShow" class="xp-hot-keywords-area">\n                <p class="xp-hot-keywords-title" v-text="i18n.hotKeywords"></p>\n                <ul class="xp-hot-keywords-list">\n                <img :src="require.toUrl(\'images/fire.png\')"/>\n                  <li v-for="(keyWord, index) in hotKeyWords" :key="index" class="xp-hot-keywords">\n                    <a target="_blank" :href="\'/catalogsearch/result/?q=\' + keyWord" @click="onSearchWordClicked(\'hot\', keyWord)" v-text="keyWord"></a>\n                  </li>\n                </ul>\n              </div>\n              <div v-show="!isKeyWordsShow" class="xp-search-reults">\n                <ul class="xp-search-list">\n                  <li v-for="(item, index) in productList" :key="index" class="xp-search-item">\n                    <a :href="item.product_url">\n                      <img :src="item.imgurl" />\n                      <div class="xp-search-product">\n                        <p class="xp-search-product-name" v-text="item.name"></p>\n                        <p class="xp-search-product-sale" v-if="parseInt(item.max_price) > parseInt(item.final_price)" v-html="item.final_price_label"></p>\n                        <p class="xp-search-product-sale" :class="{\'xp-search-product-price\': parseInt(item.max_price) > parseInt(item.final_price)}" v-html="item.max_price_label"></p>\n                      </div>\n                    </a>\n                  </li>\n                </ul>\n              </div>\n            </div>\n          </div>\n        </transition>\n      </div>\n    ',
    data: function data() {
      return {
        isKeyWordsShow: true,
        i18n: {
          find: 'Search products, brands and categories',
          hotKeywords: 'Recommendation',
          history: "History"
        },
        keyWords: '',
        page: 1,
        pageSize: 5,
        productList: [],
        hotKeyWords: [],
        showModal: false,
        searchHis: []
      };
    },
    mounted: function mounted() {
      this.init();
      this.getHisByLocal();
    },

    watch: {
      keyWords: function keyWords(newKw, oldKw) {
        if (newKw) {
          this.isKeyWordsShow = false;
          this.getKeyWords();
        } else {
          this.isKeyWordsShow = true;
        }
      }
    },
    methods: {
      init: function init() {
        var _this = this;

        this.hotKeyWords = [].concat(_toConsumableArray(window.commonDataJSON.trending_search_kws));
        $(window).on("click", function () {
          _this.closeSearchModal();
        });
      },
      onInputFocus: function onInputFocus() {
        this.showModal = true;
      },
      closeSearchModal: function closeSearchModal() {
        this.showModal = false;
        this.productList = [];
        this.keyWords = '';
        busEvent.$emit('hideSearchEvent');
      },

      // 阻止搜索模太框点击事件冒泡到window
      onSearchModalClicked: function onSearchModalClicked() {},
      submit: function submit() {
        var _this2 = this;

        if (this.searchHis.length >= 6) {
          this.searchHis.pop();
        }
        // 将搜索的记录保存到第一位
        if (this.keyWords) {
          this.searchHis = this.searchHis.filter(function (item) {
            return item !== _this2.keyWords;
          });
          this.searchHis.unshift(this.keyWords);
        }
        var res = JSON.stringify(this.searchHis);
        // 保存到localStorage
        window.localStorage.setItem('searchHistory', res);
        if (this.keyWords) {
          Util.redirect('/catalogsearch/result/?q=' + this.keyWords);

          new GAReport().customerClick({
            eventAction: this.keyWords,
            eventCategory: 'SEARCH_KEY_#VERSION#'
          });
        }
      },
      deleteHistory: function deleteHistory() {
        window.localStorage.removeItem('searchHistory');
        window.history.go(0);
      },

      // 从缓存获取搜索记录
      getHisByLocal: function getHisByLocal() {
        var res = window.localStorage.getItem('searchHistory');
        if (res) {
          this.searchHis = JSON.parse(res);
        }
      },

      /**
       * 获取预搜索列表
       */
      getKeyWords: Util.debounce(function () {
        var _this3 = this;

        var keyWords = this.keyWords;

        // 输入搜索词事件
        new GAReport().searchData({
          searchTerm: this.keyWords
        });

        searchSortApi({
          kws: this.keyWords,
          page: this.page,
          pageSize: this.pageSize
        }).then(function (resData) {
          if (resData.items.length > 0) {
            _this3.productList = resData.items;

            var offset = (_this3.page - 1) * _this3.pageSize;
            new GAReport().productExposure({
              'eventAction': 'HOME_SEARCH_SUGFESTION',
              'eventCategory': 'HOME_PRODUCT_EXPOSURE_#VERSION#',
              'productList': new GAReport().productList(_this3.productList, offset)
            });
          } else {
            _this3.productList = [];
          }
        });
      }, 500),
      // 推荐词和热词点击
      onSearchWordClicked: function onSearchWordClicked(type, text) {
        if (type === "history") {
          new GAReport().customerClick({
            eventAction: text,
            eventCategory: 'SEARCH_HISTORY_#VERSION#'
          });
        } else if (type === "hot") {
          new GAReport().customerClick({
            eventAction: text,
            eventCategory: 'SEARCH_RECOMMEND_#VERSION#'
          });
        }
      }
    }
  };
});
